import React, { useState } from 'react';
import { useGeneralInformationMessage } from '../../hooks/use-general-information-message';
import { generalInformationStorage } from '../../storage/general-information-storage';
import { GeneralInformationBanner } from '../GeneralInformationBanner/GeneralInformationBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlayGeneralInformationBanner = () => {
  const message = useGeneralInformationMessage();
  const [isVisible, setVisible] = useState(true);
  return isVisible && /*#__PURE__*/_jsx(GeneralInformationBanner, {
    message: message && !generalInformationStorage.getClosedMessageIds().includes(message.id) ? message : null,
    onClose: id => {
      setVisible(false);
      generalInformationStorage.addClosedMessageId(id);
    }
  });
};